export default __webpack_public_path__ + "static/media/oluwaseun.d6a42631.png";